// 📄 utils/displayName.ts
// user.displayName solo lo traen las cuentas creadas por createProjectMember
// (Admin SDK con displayName); profile.name es su equivalente en Firestore
// (editable desde "Mi perfil"). Para el resto (login self-service) caemos
// al local-part del email. Fuente única para UserMenu y MiPerfil, así el
// avatar/nombre nunca queda desincronizado entre ambas vistas.
export function getDisplayName(user: any, profile: any): string {
  if (user?.displayName) return user.displayName;
  if (profile?.name) return profile.name;
  if (user?.email) return user.email.split('@')[0];
  return 'Usuario';
}

export function getInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
